import { C, P0, R, S, abs, fillAt, max } from '../../geometry';

export const sparkle = {
  name: 'Sparkle',
  colors: ['#E3A008', '#8E4EC6'],
  draw(m, t) {
    let Rr = 40,
      ri = 15,
      spin = 5 * S(t * 0.6),
      tw = 0.6 + 0.4 * S(t * 3),
      pose = P0();
    if (m === 'happy') {
      Rr = 42 + 3 * abs(S(t * 7));
      spin = 15 * S(t * 5);
      pose.ty = -2 * abs(S(t * 6));
      tw = 1;
    }
    // Thinking: the star keeps turning while its little twin twinkles.
    if (m === 'thinking') {
      spin = t * 45;
      Rr = 38 + 3 * S(t * 3);
      tw = 0.5 + 0.5 * S(t * 6);
    }
    if (m === 'talking') Rr = 40 + 3 * max(0, S(t * 10));
    if (m === 'surprised') {
      Rr = 46;
      ri = 14;
    }
    if (m === 'paused') {
      Rr = 31;
      ri = 19;
      spin = 0;
      tw = 0.3;
    }
    const star = [...Array(9)].map((_, k) => {
      const a = (k * 45 - 90) * R,
        r = k % 2 ? ri : Rr;
      return [50 + r * C(a), 52 + r * S(a)];
    });
    const mini = [...Array(9)].map((_, k) => {
      const a = (k * 45 - 90) * R,
        r = k % 2 ? 2.4 : 7;
      return [84 + r * C(a), 16 + r * S(a)];
    });
    return {
      strokes: [
        { c: 'a', pts: star, sharp: true, n: 64, spin },
        {
          c: 'b',
          pts: mini,
          sharp: true,
          n: 40,
          o: tw,
          detail: true,
          spin: -spin * 2,
          pivot: [84, 16],
        },
      ],
      eyes: { x: 50, y: 52 },
      pose,
    };
  },
  eyesOn: 'a',
  solid: (f) => fillAt(f, 0, 1),
};
